import Vue, { VueConstructor } from "vue";
import ConfirmationPopup from "@/components/dialogs/confirmation-popup.vue";

export interface ConfirmPopupOptions {
  type: "WARNING" | "DANGER";
  title: string;
  message: string;
  buttonText?: string;
}

export function useConfirmPopup(
  options: ConfirmPopupOptions
): Promise<boolean> {
  return new Promise((resolve) => {
    const DialogClass = Vue.extend(
      ConfirmationPopup as unknown as VueConstructor<Vue>
    );

    let instance: Vue;

    function cleanup() {
      instance.$destroy();
      if (instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el);
      }
    }

    instance = new DialogClass({
      propsData: {
        isVisible: true,
        type: options.type,
        title: options.title,
        message: options.message,
        buttonText: options.buttonText,
        onConfirm: () => {
          resolve(true);
          cleanup();
        },
        onClose: () => {
          resolve(false);
          cleanup();
        },
      },
    });

    instance.$mount();
    document.body.appendChild(instance.$el);
  });
}
